import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./Kyc.module.css";
import { useAuth } from "../../components/context/Auth";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import Button from "../../components/updatedComponents/Dealers/Button";
import { AddBtnicon, TemplateNotFound, Transfer } from "../../components/icons/Icon2";
import GoToPage from "../../components/updatedComponents/Pagnation/GoToPage";
import Pagenation from "../../components/updatedComponents/Pagnation/Pagenation";
// import DrawerWrapper from "../../components/updatedComponents/layoutWrapper/DrawerWrapper";
import fetchData from "../../APIsControll/apiControll";
import { truncateText } from "../../Utils/TextUtils";
// import LocationSarchFilter from "../../components/updatedComponents/Filter/LocationSarchFilter";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import ModalWrapper from "../../components/updatedComponents/layoutWrapper/ModalWrapper";
import { useNavigate } from "react-router-dom";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import { DispatchReloadIcon } from "../../components/icons/Icon";
import SearchBar from "../../components/updatedComponents/FormComponents/SearchBar";
// import DropDown from "../../components/updatedComponents/FormComponents/DropDown";
const TransferDealer = () => {
  const { mode, managerId } = useAuth();
  const { show } = useToast();
  const forRef1 = useRef(null);
  const toRef1 = useRef(null);

  const [formManger, setFormManger] = useState(false);
  const [ToManger, setToManger] = useState(false);
  const [serachDealer, setSarchDealer] = useState("");

  const [loading, setLoading] = useState({
    loading1: false,
    loading2: false,
    loading3: false,
    loading4: false,
    loading5: false,
  });
  const [selectManager, stSelectManager] = useState({
    formManger: "",
    formMangerId: "",
    toManger: "",
    toMangerId: "",
  });


  // console.log("selectManager",selectManager);
  

  const [error, setError] = useState({});
  const [loadin3, setLoading3] = useState(false);
  const navigator = useNavigate();

  // const [allSelect, setAllSelect] = useState();
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [formpage, setFormPage] = useState(1);
  const [formpages, setFormPages] = useState(1);
  const [Formdata, setFormdata] = useState([]);
  const [bulkSentStatus, setBulkSentStatus] = useState(false);
  const [groupDealer, setgroupDealer] = useState([]);
  // const [unCheckedDealers, setUnCheckedDealers] = useState([]);
  const [getDealersByAllId, setGetDealersByAllId] = useState([]);

  const [Topage, setToPage] = useState(1);
  const [Topages, setToPages] = useState(1);
  const [Todata, setTodata] = useState([]);
  const [tosarch, setSarch] = useState("");
  const [formsarch, setFormarch] = useState("");


  const [state, setState] = useState({
    locationList: [],
    searchValue: "",
    selectFilter: [],
  });
  const [District, setDistrict] = useState({
    locationList: [],
    searchValue: "",
    selectFilter: [],
  });
  const [City, setCity] = useState({
    locationList: [],
    searchValue: "",
    selectFilter: [],
  });
  const [DealerByMangerData, setDealerByMangerData] = useState([]);



  //  form collback
  const formData = useCallback(async () => {
    if (loading.loading1) return;
    try {
      const payload = {
        managerId: managerId,
        keyword: formsarch,
        warehousename: "",
        designation: "",
        status: "",
        locations: {
          states: [],
          districts: [],
          cities: [],
          pincodes: [],
        },
      };
      setLoading({ ...loading, loading1: true });
      const res = await fetchData(`managers/allManagersList?page=${formpage}&limit=50`, payload);
      if (res.status === "success") {
        setFormPages(res.pages);
        setFormdata((prev) => {
          if (formsarch) {
            return res.data;
          } else {
            return [...prev, ...res.data];
          }
        });
      }
      if (res.status === "failed") {
        setFormdata([]);
        setFormPage(1);
        show(res.msg, "error");
        return;
      }
    } catch (error) {
      show(error.massage, "error");
    } finally {
      setLoading({ ...loading, loading1: false });
    }
  }, [managerId, formsarch, formpage, show, loading]);

  //  to collbak
  const getToData = useCallback(async () => {
    if (loading.loading2) return;
    try {
      const payload = {
        managerId: managerId,
        keyword: tosarch,
        warehousename: "",
        designation: "",
        status: "",
        locations: {
          states: [],
          districts: [],
          cities: [],
          pincodes: [],
        },
      };
      const res = await fetchData(`managers/allManagersList?page=${Topage}&limit=50`, payload);
      if (res.status === "success") {
        setToPages(res.pages);
        if (formsarch.trim()) {
          setTodata(res.data);
        } else {
          setTodata((prev) => [...prev, ...res.data]);
        }
        return;
      }
      if (res.status === "failed") {
        setTodata([]);
        setToPage(1);
        show(res.msg, "error");
        return;
      }
    } catch (error) {
      // show(error.massage, "error");
    }
  }, [loading.loading2, managerId, tosarch, Topage, formsarch, show]);

  const resetFilters = () => {
    stSelectManager({
      formManger: "",
      formMangerId: "",
      toManger: "",
      toMangerId: "",
    });
    setBulkSentStatus(false);
    setgroupDealer([]);
    setDealerByMangerData([]);
  }

  useEffect(() => {
    formData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managerId, formsarch, formpage]);

  useEffect(() => {
    getToData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [managerId, formsarch, Topage]);

  //  handelScroll
  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 50) {
      if (!loading.loading1 && formpage < formpages) {
        setFormPage(formpage + 1);
        return;
      }
    }
  };

  //  handelScroll
  const handleScroll2 = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 50) {
      if (!loading.loading2 && Topage < Topages) {
        setToPage(Topage + 1);
        return;
      }
    }
  };

  // HandeSelectInputBox
  const HandeSelectInputBox = async (event, item) => {
    const { checked } = event.target;
    const { dealerId } = item;
    if (checked) {
      setgroupDealer((prev) => [...prev, dealerId]);
    } else {
      setgroupDealer((prev) => prev.filter((id) => id !== dealerId));
    }
  };

  // getDealerIds
  // const getDealerByManagerId = useCallback(async () => {
  //   setLoading3(true);
  //   try {
  //     const payload = {
  //       managerId,
  //       currentManagerId: selectManager.formMangerId,
  //       keyword: serachDealer,
  //       status: "",
  //       locations: {
  //         states: state.selectFilter,
  //         districts: District.selectFilter,
  //         cities: City.selectFilter,
  //         pincodes: [],
  //       },
  //     };
  //     const res = await fetchData(`kyc/getDealersByManager?page=${page}`, payload);
  //     if (res.status === "success") {
  //       setDealerByMangerData(res?.data);
  //       setPages(res?.pages);
  //       setPage(res?.page);
  //       return;
  //     }
  //     if (res.status === "failed") {
  //       setDealerByMangerData([]);
  //       setPages(1);
  //       setPage(1);
  //       return;
  //     }
  //     // //console.log(res);
  //   } catch (error) {
  //     show(error.message, "error");
  //   } finally {
  //     setLoading3(false);
  //   }
  // }, [City.selectFilter, District.selectFilter, serachDealer, managerId, page, selectManager.formMangerId, show, state.selectFilter]);

  const getDealerByManagerId = async () => {
    setLoading3(true);
    try {
      const payload = {
        managerId,
        currentManagerId: selectManager.formMangerId,
        keyword: serachDealer,
        status: "",
        locations: {
          states: state.selectFilter,
          districts: District.selectFilter,
          cities: City.selectFilter,
          pincodes: [],
        },
      };
      const res = await fetchData(`kyc/getDealersByManager?page=${page}&limit=15`, payload);
      if (res.status === "success") {
        setDealerByMangerData(res?.data);
        setPages(res?.pages);
        setPage(res?.page);
        return;
      }
      if (res.status === "failed") {
        setDealerByMangerData([]);
        setPages(1);
        setPage(1);
        return;
      }
      // //console.log(res);
    } catch (error) {
      show(error.message, "error");
    } finally {
      setLoading3(false);
    }
  }
  useEffect(()=>{
    getDealerByManagerId(); 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [City.selectFilter, District.selectFilter, serachDealer, managerId, page, selectManager.formMangerId,  state.selectFilter])


  useEffect(() => {
    if (selectManager.formManger !== "") {
      getDealerByManagerId();
      getDealerIds();
      setError({ ...error, formMangerId: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectManager.formMangerId]);

  useEffect(() => {
    setError({ ...error, ToMangerId: "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectManager.toMangerId])


  useEffect(() => {
    if (bulkSentStatus) {
      setgroupDealer(getDealersByAllId);
    }
    if (!bulkSentStatus) {
      setgroupDealer([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkSentStatus]);

  //  transferDealersInBulk
  const getDealerIdInbulk = async () => {
    if (selectManager.formMangerId === "") {
      setError({ ...error, formMangerId: "Please Select From Manager" });
      return;
    }
    if (selectManager.toManger === "") {
      setError({ ...error, ToMangerId: "Please Select To Manager" });
      return;
    }
    if (groupDealer.length === 0) {
      show("Please Select Dealer", "error");
      return;
    }

    try {
      setLoading({ ...loading, loading4: true });
      const payload = {
        managerId: managerId,
        currentManagerId: selectManager.formMangerId,
        newManagerId: selectManager.toMangerId,
        dealerIds: groupDealer,
      };
      const res = await fetchData(`kyc/transferDealers`, payload);
      if (res.status === "success") {
        show(res.msg, "success");
        navigator(-1);
      }
      if (res.status === "failed") {
        show(res.msg, "error");
      }
    } catch (error) {
      show(error.message, "error");
    } finally {
      setLoading({ ...loading, loading4: false });
    }
  };

  //  getDealerIds
  const getDealerIds = async () => {
    try {
      setLoading({ ...loading, loading5: true });
      const payload = {
        managerId: managerId,
        currentManagerId: selectManager.formMangerId,
        keyword: "",
        status: "",
        locations: { states: [] }
      }
      const res = await fetchData(`kyc/getDealerIds`, payload);
      setGetDealersByAllId(res.dealerIds);
    } catch (error) {

    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (toRef1.current && !toRef1.current.contains(event.target)) {
        setToManger(false)
      }
      if (forRef1.current && !forRef1.current.contains(event.target)) {
        setFormManger(false)
      }
    };
    if (ToManger || formManger) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ToManger, formManger]);

  // console.log("selectManager", selectManager);


  return (
    <div className={styles.main2}>
      <div className={styles.continer} style={{ backgroundColor: mode ? "#2C2E33" : "#F8F9FC" }}  >
        {/* <DrawerWrapper
          isOpen={isOpen.Darwer}
          onClose={() => setIsOpen((pre) => ({ ...pre, Darwer: !isOpen.Darwer, }))} >
          <div
            className={mode ? styles.DrawerWrapperContinetr : styles.DrawerWrapperContinetr_light} >
            <div className={styles.btn}>
              <div>
                <Button
                  buttonBgColor={"#000"}
                  buttonText={"Back"}
                  buttonTextColor={"#fff"}
                  buttonIcon={<Transfer />}
                  buttonClick={() => setIsOpen((pre) => ({ ...pre, Darwer: !isOpen.Darwer, }))} />
              </div>
            </div>
            <div>
              <div style={{ width: "120px" }}>
                <Button
                  buttonBgColor={"#4164E3"}
                  buttonText={"Transfer"}
                  buttonTextColor={"#fff"}
                  buttonIcon={<Transfer />}
                  buttonClick={getDealerIdInbulk}
                  loading={loading.loading4}
                />
              </div>
            </div>
          </div>
        </DrawerWrapper> */}

        <div className={styles.go_back}>
          <div>
            <TopTabBar text={"Transfer Dealer"} />
          </div>
          <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <div  >
              <Button
                buttonBgColor={"#000000"}
                buttonTextColor={"#ffffff"}
                buttonIcon={<DispatchReloadIcon />}
                buttonClick={() => resetFilters()}
              />
            </div>
            <div style={{ width: "120px" }}>
              <Button
                buttonBgColor={"#4164E3"}
                buttonText={"Transfer"}
                buttonTextColor={"#fff"}
                buttonIcon={<Transfer />}
                // buttonClick={() => setIsOpen((pre) => ({ ...pre, Darwer: !isOpen.Darwer, }))} 
                buttonClick={getDealerIdInbulk}
                loading={loading.loading4}
              />
            </div>
          </div>
        </div>

        <div
          className={styles.filter_cantiner}
          style={{ color: mode ? "#fff" : "#000" }}
        >
          <div className={styles.select_dealer}>
            <div className={styles.select_dealerCont}>
              <div> From </div>
              <div>
                <div
                  className={styles.select_main_Manager}
                  style={{
                    border: mode ? "none" : "1px solid #ccc",
                    backgroundColor: mode ? "#1D1F23" : "#fff",
                  }}
                // ref={forRef}
                >
                  <div
                    className={styles.select_manager}
                    onClick={() => setFormManger(!formManger)}
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%", justifyContent: "space-between", padding: "3px"
                      }}
                    >
                      <div>
                        {" "}
                        {truncateText(selectManager.formManger, 19) ||
                          "Select"}{" "}
                      </div>
                      <div>
                        <AddBtnicon
                          mode={mode} rotate={formManger ? 180 : 0}
                        />{" "}
                      </div>
                    </div>
                  </div>
                  {formManger && (
                    <div
                      className={styles.select_abslut_manager1}
                      style={{
                        background: mode ? "#2C2E33" : "#fff",
                        color: mode ? "#fff" : "#000",
                        border: mode ? "none" : "1px solid #ccc",
                      }}
                      ref={forRef1}
                    >
                      <div>
                        <input
                          type="text"
                          name="Form"
                          className={styles.select_box_input}
                          placeholder="Sarching..."
                          style={{
                            border: mode ? "none" : "1px solid #ccc",
                            backgroundColor: mode ? "#000" : "#fff",
                            color: mode ? "#fff" : "#000",
                          }}
                          onChange={(e) => setFormarch(e.target.value)}
                        />
                      </div>
                      <div
                        className={styles.Select_scroll_con}
                        onScroll={handleScroll}
                      >
                        <>
                          {Formdata?.map((item, index) =>
                            item.designation.includes('ordermanager') &&
                            (
                              <div
                                className={
                                  mode
                                    ? styles.select_manger_dark
                                    : styles.select_manger_light
                                }
                                key={index}
                                onClick={() => {
                                  stSelectManager({
                                    ...selectManager,
                                    formManger: item.name,
                                    formMangerId: item.managerId,
                                  });
                                  // setIsOpen({ ...isOpen, Form: false });
                                  // setIsOpen((pre) => ({ ...pre, Form: !isOpen.Form, }));
                                  setFormManger(false)
                                }}
                              >

                                <span>{truncateText(item.name, 19)}</span>
                              </div>
                            ))}
                        </>
                      </div>
                    </div>
                  )}
                  {error.formMangerId && <div className={styles.selectMang}>{error.formMangerId}  </div>}

                </div>
              </div>
            </div>
            <div className={styles.select_dealerCont}>
              <div> To </div>
              <div>
                <div
                  className={styles.select_main_Manager}
                  style={{
                    border: mode ? "none" : "1px solid #ccc",
                    backgroundColor: mode ? "#1D1F23" : "#fff",
                  }}
                // ref={toRef}
                >
                  <div
                    className={styles.select_manager}
                    onClick={() => setToManger(true)}
                  // ref={toRef1}
                  >
                    <div style={{
                      display: "flex", justifyContent: "space-between",
                      padding: "3px", width: "100%",
                    }} >
                      <div>
                        {" "}
                        {truncateText(selectManager.toManger, 19) ||
                          "Select"}{" "}
                      </div>
                      <div>
                        <AddBtnicon mode={mode} rotate={ToManger ? 180 : 0} />{" "}
                      </div>
                    </div>
                  </div>
                  {ToManger && (
                    <div
                      className={styles.select_abslut_manager1}
                      style={{
                        background: mode ? "#2C2E33" : "#fff",
                        color: mode ? "#fff" : "#000",
                        border: mode ? "none" : "1px solid #ccc",
                      }}
                      ref={toRef1}
                    >
                      <div>
                        <input
                          type="text"
                          name="To"
                          className={styles.select_box_input}
                          placeholder="Sarching..."
                          style={{
                            border: mode ? "none" : "1px solid #ccc",
                            backgroundColor: mode ? "#000" : "#fff",
                            color: mode ? "#fff" : "#000",
                          }}
                          onChange={(event) => setSarch(event.target.value)}
                        />
                      </div>
                      <div
                        className={styles.Select_scroll_con}
                        onScroll={handleScroll2}
                      >
                        <>
                          {Todata?.map((item, index) =>
                            item.designation.includes('ordermanager') &&
                            (
                              <div
                                className={
                                  mode
                                    ? styles.select_manger_dark
                                    : styles.select_manger_light
                                }
                                key={index}
                                onClick={() => {
                                  stSelectManager({
                                    ...selectManager,
                                    toManger: item.name,
                                    toMangerId: item.managerId,
                                  });
                                  // setIsOpen({ ...isOpen, To: false });
                                  // setIsOpen((pre) => ({ ...pre, To: !isOpen.To, }))
                                  setToManger(false)
                                }}
                              >
                                <span>{truncateText(item.name, 19)}</span>
                              </div>
                            ))}
                        </>
                      </div>
                    </div>
                  )}
                  {error.ToMangerId && <div className={styles.selectMang}>{error.ToMangerId}  </div>}

                </div>
              </div>
            </div>
            <div className={styles.select_dealerCont}>
              {
                selectManager.formManger !== "" ?
                  <div style={{ fontSize: "12px" }}>
                    <SearchBar
                      padding={"6px"}
                      fontSize={"12px"}
                      fontWeight={"400"}
                      borderRadius={"5px"}
                      placeholder={"Search Dealer"}
                      value={serachDealer}
                      onChange={(e) => {
                        setSarchDealer(e.target.value);
                      }}
                    />
                  </div> : null
              }
            </div>
          </div>
          {/* <div className={styles.Transfer_loction}>
            <LocationSarchFilter
              text={"State"}
              list={state.locationList}
              search={state.searchValue}
              setSearch={(value) =>
                setState((prevState) => ({ ...prevState, searchValue: value }))
              }
              selectFilter={state.selectFilter}
              setSelectFilter={(value) =>
                setState((prevState) => ({ ...prevState, selectFilter: value }))
              }
            />
            <LocationSarchFilter
              text={"District"}
              list={District.locationList}
              search={District.searchValue}
              setSearch={(value) =>
                setDistrict((prevState) => ({
                  ...prevState,
                  searchValue: value,
                }))
              }
              selectFilter={District.selectFilter}
              setSelectFilter={(value) =>
                setDistrict((prevState) => ({
                  ...prevState,
                  selectFilter: value,
                }))
              }
            />
            <LocationSarchFilter
              text={"City"}
              list={City.locationList}
              search={City.searchValue}
              setSearch={(value) =>
                setCity((prevState) => ({ ...prevState, searchValue: value }))
              }
              selectFilter={City.selectFilter}
              setSelectFilter={(value) =>
                setCity((prevState) => ({ ...prevState, selectFilter: value }))
              }
            />
            <div style={{ fontSize: "12px" }}>
              <DropDown
                label={"Status"}
                options={[{ label: "name" }, { label: "Age" }]}
              />
            </div>
          </div> */}
        </div>

        <div className={styles.tableContiner}>
          <div className={styles.container} style={{ height: "100%" }}>
            <ul className={styles.responsiveTable} style={{ height: "100%" }}>
              <li
                className={styles.tableHeader}
                style={
                  mode
                    ? { backgroundColor: "#232529", color: "#fafafa" }
                    : { backgroundColor: "#D9DCE5" }
                }
              >
                <div className={`${styles.col} `}>
                  <label className={styles.cl_checkbox}>
                    <input
                      type="checkbox"
                      onChange={(e) => setBulkSentStatus(e.target.checked)}
                      checked={bulkSentStatus}
                    />
                    <span></span>
                  </label>
                  Dealer ID
                </div>
                <div className={`${styles.col}`}>Dealer Name </div>
                <div className={styles.col}>Store Name</div>
                <div className={styles.col}>City</div>
                <div className={styles.col}>State</div>
                <div className={styles.col}>Designation</div>
                <div className={styles.col}>GSTUIN</div>
              </li>
              <div className={styles.scrolllist}>
                {loadin3 ? (<div>
                  <Skeleton lines={5} thickness={5} />
                </div>) :
                  DealerByMangerData.length === 0 && selectManager.formManger === "" ? <div className={styles.noDataFound}>
                    <NoDataFound
                      icon={<TemplateNotFound />}
                      textTitle={"Please Select Manager"}
                    /> </div>
                    : (DealerByMangerData.length === 0 && selectManager.formManger !== "") ?
                      <div className={styles.noDataFound}>
                        <NoDataFound
                          icon={<TemplateNotFound />}
                          textTitle={"Dealers Not Found"}
                        />
                      </div> :
                      (
                        DealerByMangerData.map((item, i) => {
                        // Array.from({length: 20}).map((item, i) => {
                          return (
                            <li
                              className={styles.tablerow}
                              style={
                                mode ? { backgroundColor: "#1B1D21", color: "#fafafa" } : { backgroundColor: "#ffff" }}
                              key={i}
                            >
                              <div
                                className={`${styles.col} ${styles.coljustyfy}   `}
                                data-label="Dealer Name"
                              >
                                <div className={styles.TableHeadChackBox}>
                                  <label className={styles.cl_checkbox}>
                                    <input
                                      type="checkbox"
                                      onChange={(event) =>
                                        HandeSelectInputBox(event, item)
                                      }
                                      checked={groupDealer.includes(item.dealerId)}
                                    />
                                    <span></span>
                                  </label>
                                </div>
                                <div>{truncateText(item?.dealerId, 19)}</div>
                              </div>
                              <div className={`${styles.col}`} data-label="Address">
                                {" "}
                                {truncateText(item?.name, 19)}
                              </div>
                              <div className={styles.col} data-label="State">
                                {" "}
                                {truncateText(item?.storeName, 19)}{" "}
                              </div>
                              <div className={styles.col} data-label="District">
                                {" "}
                                {truncateText(item?.city, 19)}{" "}
                              </div>
                              <div className={styles.col} data-label="City">
                                {" "}
                                {truncateText(item?.state, 19)}{" "}
                              </div>
                              <div className={styles.col} data-label="PIN Code">
                                {" "}
                                {truncateText(item?.designation, 19)}{" "}
                              </div>
                              <div className={styles.col} data-label="Status">
                                {" "}
                                {truncateText(item?.gstuin, 19)}{" "}
                              </div>
                            </li>
                          );
                        })
                      )}
              </div>
            </ul>
          </div>
        </div>
      </div>

      <div
        className={styles.pageContiner}
        style={{ backgroundColor: mode ? "#232529" : "#fff" }}
      >
        <div
          style={{
            width: "50%",
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <GoToPage
            currentPage={page}
            setCurrentPage={setPage}
            totalPages={pages}
            key={"1"}
          />
        </div>
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "50%" }}
        >
          <Pagenation
            currentPage={page}
            setCurrentPage={setPage}
            totalPages={pages}
            key={"1"}
          />
        </div>
      </div>
    </div>
  );
};

export default TransferDealer;
